import React, { useState,useEffect } from 'react'
import { ChevronRight, ChevronLeft, LayoutDashboard, ReceiptText, ClipboardMinus, History, ShoppingBasket, UsersRound, Tag } from 'lucide-react'
import Accordion from 'react-bootstrap/Accordion';
import Product from '../../components/product/Product';
import Dashboard from '../../components/dashboard/Dashboard';
import Bills from '../../components/bills/Bills';
import Reports from '../../components/reports/Reports';
import OrderHistory from '../../components/orderHistory/OrderHistory';
import Cashiers from '../../components/cashiers/Cashiers';
import Categories from '../../components/categories/Categories';
import style from "./AdminPanel.module.scss"
import {STORAGE_KEYS} from '../../utils/constants/storageKeys';
/**
 * @component AdminPage
 * 
 * @description
 * Admin page that consists other administrative components such as 
 * Dashboard, product, bills, reports, order history
 * 
 * @author
 * Susovan Mishra | susovanm@ovaku.in
 * 
 */
function AdminPage() {

  //Tracking if the navbar is collapsed or not
  const [collapsed, setCollapsed] = useState(false);
  
  //Tracking mobile screen width
  const [isMobile, setIsMobile] = useState(window.innerWidth < 645);

  //Tracking active tab and saving them in local storage for keeping tab persist on page reload
  const [activeTab, setActiveTab] = useState(() => {return localStorage.getItem(STORAGE_KEYS.ACTIVE_DASHBOARD_TAB) || "db"});

  // Handle window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 645);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.ACTIVE_DASHBOARD_TAB, activeTab);
  }, [activeTab])
  return (
    <div className='d-flex' style={{ height: '100vh' }}>
      {/* Side bar design to be shown when window width greater than 645 px */}
    <div
      className={`${style.navBarContainer} d-flex flex-column border-end bg-white transition-all ${collapsed ? 'collapsed-sidebar' : 'expanded-sidebar'}`}
       style={{ 
         width: collapsed ? (isMobile ? '0px' : '100px') : '200px',
         flexShrink: 0
       }}
    >
      <div className="d-flex align-items-center justify-content-between p-3" style={{borderBottom: collapsed ? 'none' : '1px solid #dee2e6'}}>
        {!collapsed ? (
          <div className="d-flex align-items-center">
            <span className="ms-2 fw-semibold text-dark" style={{ fontSize: "25px" }}>Orderly</span>
          </div>
        ) : null}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="btn d-flex btn-light btn-sm p-1"
        >
          {
            collapsed ? <ChevronRight size={18} className={`transition-transform justify-content-end`} /> : <ChevronLeft size={18} className={`transition-transform`} />
          }
        </button>
      </div>
          {/* Nav links rendered from here */}
          <div className="flex-grow-1 overflow-auto py-3">
            <nav className="nav gap-2 flex-column">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("db");
                }}
                className={`${style.linkTabs} nav-link gap-2 mx-4 d-flex align-items-center ${activeTab === "db" ? `bg-blue text-white` : ""}`}
                style={{ justifyContent: collapsed ? 'center' : 'flex-start', backgroundColor:activeTab === "db" ? "  #80bfff":"" }}
              >
                <div className={``}>
                  <LayoutDashboard color={activeTab === "db" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color:activeTab === "db" ? "white" : ""}}>Dashboard</span>}
              </a>

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("product");
                }}
                className={`${style.linkTabs} nav-link gap-2 mx-4 d-flex align-items-center ${activeTab === "reports" ? `bg-blue text-white` : ""}`}
                style={{ justifyContent: collapsed ? 'center' : 'flex-start', backgroundColor: activeTab === "product" ? "#80bfff" : "" }}
              >
                <div>
                  <ShoppingBasket color={activeTab === "product" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color: activeTab === "product" ? "white" : ""}}>Product</span>}
              </a>

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("categories");
                }}
                className={`${style.linkTabs} nav-link gap-2 mx-4 d-flex align-items-center ${activeTab === "categories" ? `bg-blue text-white` : ""}`}
                style={{ justifyContent: collapsed ? 'center' : 'flex-start', backgroundColor: activeTab === "categories" ? "#80bfff" : "" }}
              >
                <div>
                  <Tag color={activeTab === "categories" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color: activeTab === "categories" ? "white" : ""}}>Categories</span>}
              </a>

              {/* Bills link commented out */}
              {/* <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("bills");
                }}
                className={`${style.linkTabs} nav-link d-flex mx-4 align-items-center ${activeTab === "bills" ? `bg-blue text-white` : ""}`}
                style={{gap:2, justifyContent: collapsed ? 'center' : 'flex-start',backgroundColor: activeTab === "bills" ? "#80bfff"  : "" }}
              >
                <div>
                  <ReceiptText color={activeTab === "bills" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color:activeTab === "bills" ? "white" : ""}}>Bills</span>}
              </a> */}

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("reports");
                }}
                className={`${style.linkTabs} nav-link gap-2 mx-4 d-flex align-items-center ${activeTab === "reports" ? ` text-white` : ""}`}
                style={{ justifyContent: collapsed ? 'center' : 'flex-start',backgroundColor:activeTab === "reports" ? "#80bfff" : "" }}
              >
                <div>
                  <ClipboardMinus color={activeTab === "reports" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color:activeTab === "reports" ? "white" : ""}}>Reports</span>}
              </a>

                
                <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("cashiers");
                }}
                className={`${style.linkTabs} nav-link gap-2 d-flex mx-4 align-items-center ${activeTab === "cashiers" ? `bg-blue text-white` : ""}`}
                style={{color:activeTab === "cashiers" ? "white" : "", justifyContent:  collapsed ? 'center' : 'flex-start',backgroundColor: activeTab === "cashiers" ? "#80bfff" : "" }}
              >
                <div>
                  <UsersRound color={activeTab === "cashiers" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color: activeTab === "cashiers" ? "white" : ""}}>Cashiers</span>}
              </a>
              
              {/* Order History link commented out */}
              {/* <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("history");
                }}
                className={`${style.linkTabs} nav-link gap-2 d-flex mx-4 align-items-center ${activeTab === "history" ? `bg-blue text-white` : ""}`}
                style={{color: activeTab === "history" ? "white" : "",  justifyContent: collapsed ? 'center' : 'flex-start', backgroundColor: activeTab === "history" ? "#80bfff" : "" }}
              >
                <div>
                  <History color={activeTab === "history" ? "white" : "black"} />
                </div>
                {!collapsed && <span style={{color: activeTab === "history" ? "white" : ""}}>Order History</span>}
              </a> */}

            </nav>
          </div>
    </div>
    <div>
    </div>
    {/* Components rendered according to the active tabs */}
    <div 
      className='flex-grow-1' 
      style={{ 
        height: '100vh',
        overflow: 'auto'
      }}
    >
       {activeTab === "product" ? <Product/> : activeTab === "db" ? <Dashboard/> : activeTab === "bills" ? <Bills/> : activeTab === "reports" ? <Reports/> : activeTab === "cashiers" ? <Cashiers/> : activeTab === "categories" ? <Categories/> : <OrderHistory/>}
    </div>
    
    {/* Mobile chevron button to open sidebar when closed */}
    {isMobile && collapsed && (
      <button
        onClick={() => setCollapsed(false)}
        className="btn btn-light position-fixed"
        style={{
          top: '80px',
          left: '20px',
          zIndex: 1001,
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
      >
        <ChevronRight size={20} />
      </button>
    )}
    </div>
  );
}

export default AdminPage;
